import { useCallback, useEffect, useState } from "react";
import mapService from "services/mapService";
import type { IpCategory } from "../MapModel";

export const useMapCategories = (locale: string) => {
  const [categories, setCategories] = useState<IpCategory[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [revision, setRevision] = useState(0);
  const retry = useCallback(() => setRevision((value) => value + 1), []);
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError(false);
    mapService.getIpCategories(locale, controller.signal).then((response: any) => {
      if (controller.signal.aborted) return;
      const entries = response.data.map((entry) => ({ id: entry.id, nume: entry.attributes.nume }));
      if (!entries.some((entry) => entry.id === 11)) entries.push({ id: 11, nume: "EVENIMENTE" });
      setCategories(entries);
    }).catch(() => {
      if (!controller.signal.aborted) setError(true);
    }).finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [locale, revision]);
  return { categories, loading, error, retry };
};
